import {
    setPartnerBranding,
    setIsPartnerPreferencesOn,
    setIsPartnerPreferencesOff,
    setPartnerName,
    setPartnerLogo
} from "./branding.reducers";
import {
    api_getPartnerById,
    api_setPartnerPreferences,
    api_patchPartnerPreferences,
    api_getPartnerURLUploadLogo,
    api_getUserPartners
} from "./branding.api";
import {colorPrimary, colorSecondary} from "../../Constants/theme";

export const getUsersBranding = () => dispatch => (
    api_getUserPartners().then(res => {
        if(res.length){
            dispatch(setPartnerBranding({
                partnerId: res[0].id,
                name: res[0].name || "",
                logo: res[0].logoUrl,
                url: res[0].url,
                brandHeader: res[0].color?.header || colorPrimary,
                brandText: res[0].color?.text || colorPrimary,
                brandAccent: res[0].color?.accent || colorSecondary,
                headerFont: res[0].font?.header || "Merriweather",
                textFont: res[0].font?.text || "DMSans",
                clinicId: res[0].clinicId,
                type: res[0].type,
                redirectUrl: res[0].redirectUrl,
                headerText: res[0].headerText,
                bodyText: res[0].bodyText,
                buttonText: res[0].color?.buttonText || colorPrimary,
                partnerStatus: res[0].partnerStatus,
            }));
            return res[0];
        }
    })
);

export const createPartner = params => dispatch => (
    api_setPartnerPreferences(params).then(res => {
        dispatch(setPartnerName(res.name));
        return res;
    })
);

export const updatePartner = ({id, body}) => dispatch => (
    api_patchPartnerPreferences(id, body)
        .then(res =>
            dispatch(setPartnerBranding({
                url: res.url,
                logo: res.logoUrl,
                brandHeader: res.color?.header || colorPrimary,
                brandText: res.color?.text || colorPrimary,
                brandAccent: res.color?.accent || colorSecondary,
                headerFont: res.font?.header || "Merriweather",
                textFont: res.font?.text || "DMSans"
            }))
        )
);

export const getPartner = params => dispatch => (
    api_getPartnerById(params).then(res => {
        dispatch(setPartnerBranding({
            partnerId: res.id,
            name: res?.name,
            url: res?.url,
            logo: res?.logoUrl,
            brandHeader: res.color?.header || colorPrimary,
            brandText: res.color?.text || colorPrimary,
            brandAccent: res.color?.accent || colorSecondary,
            headerFont: res.font?.header || "Merriweather",
            textFont: res.font?.text || "DMSans",
            headerText: res?.headerText,
            bodyText: res?.bodyText,
        }));
        return res;
    })
);

export const getBranding = params => dispatch => (
    api_getPartnerById(params).then(res => {
        dispatch(setPartnerBranding({
            partnerId: res.id,
            websiteURL: `https://${res.name}.com`,
            name: res?.name,
            url: res?.url,
            logo: res.logoUrl,
            brandHeader: res.color?.header || colorPrimary,
            brandText: res.color?.text || colorPrimary,
            brandAccent: res.color?.accent || colorSecondary,
            headerFont: res.font?.header || "Merriweather",
            textFont: res.font?.text || "DMSans",
            clinicId: res.clinicId || null,
            type: res.type || null,
            redirectUrl: res.redirectUrl || null,
            headerText: res?.headerText,
            bodyText: res?.bodyText,
            buttonText: res.color?.buttonText || colorPrimary,
            partnerStatus: res?.partnerStatus
        }));
        dispatch(setIsPartnerPreferencesOn());
        return res;
    })
);
export const setIsPartnerPreferences = () => dispatch => (
    dispatch(setIsPartnerPreferencesOff())
);

export const getPartnerURLUploadLogo = params => dispatch => (
    api_getPartnerURLUploadLogo(params).then(res => {
        dispatch(setPartnerLogo(res.downloadUrl));
        return res;
    })
);
